import _extends from "@babel/runtime/helpers/extends";
import React, { Suspense } from 'react';
import { Box } from '@atlaskit/primitives';
import { AdControlContext } from '../../controllers/ad-control-provider/context';
import { adControlProviderReducer, initialAdControlProviderState } from '../../controllers/ad-control-provider/context/reducer';
import { ActIntlProvider } from '../act-intl-provider';
import { DismissalFlagGroup } from '../dismissal-flag-group';
import { ReasonsModal } from '../reasons-modal';
const AdControlProvider = ({
  children,
  onEvents = () => {},
  shouldShowDismissFlag = true
}) => {
  var _modalPropsRef$curren;
  const [state, dispatch] = React.useReducer(adControlProviderReducer, initialAdControlProviderState);
  const modalPropsRef = React.useRef();
  const modalProps = (_modalPropsRef$curren = modalPropsRef.current) !== null && _modalPropsRef$curren !== void 0 ? _modalPropsRef$curren : {
    body: '',
    title: ''
  };
  return /*#__PURE__*/React.createElement(ActIntlProvider, null, /*#__PURE__*/React.createElement(AdControlContext.Provider, {
    value: {
      state,
      modalPropsRef,
      dispatch,
      onEvents,
      shouldShowDismissFlag
    }
  }, children, /*#__PURE__*/React.createElement(ReasonsModal, _extends({
    itemId: state.modalItemId
  }, modalProps)), /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, null)
  }, /*#__PURE__*/React.createElement(DismissalFlagGroup, null))));
};
export default AdControlProvider;